import m from "../../geodata/es2015/bulgariaHigh";
window.am4geodata_bulgariaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bulgariaHigh.js
// module id = null
// module chunks = 